angular.module('aprima-core-ui').filter('apSsnFilter', function () {
        'use strict';
        return function (value) {

            if (value) {
                var val = value.toString().replace(/\D/g, '');

                var len = val.length;
                if (len < 4) {
                    return val;
                }
                else if (3 < len && len < 6) {

                    return val.substr(0, 3) + '-' + val.substr(3);
                }
                else if (len > 5) {

                    return val.substr(0, 3) + '-' + val.substr(3, 2) + '-' + val.substr(5, 4);
                }
            }
            return value;
        };
    }
);
